package com.essntl.uikit.components.chat.contact

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.unit.dp
import com.essntl.uikit.theme.esColorScheme
import com.essntl.uikit.theme.esTypography

@Composable
fun ContactTypeUI(type: ContactUiState.ContactType?) {
    Box(
        modifier = Modifier
            .clip(RoundedCornerShape(100))
            .background(MaterialTheme.esColorScheme.tinted)
            .padding(
                vertical = 4.dp,
                horizontal = 8.dp,
            ),
    ) {
        Text(
            text = type?.value ?: "Unknown",
            style = MaterialTheme.esTypography.c1Medium11.copy(
                color = MaterialTheme.esColorScheme.textAccent,
            ),
        )
    }
}